import { QR_PROFILE_SOURCE } from './qrProfile';
import { QR_REGISTRATION_SOURCE } from './qrRegistration';
import { routes } from '../routes/routes';

export const GUEST_PROFILE_PARAM = 'profile';
export const GUEST_INTAKE_STEP_PARAM = 'step';
export const GUEST_INTAKE_ROLE_PARAM = 'role';

export type GuestIntakeStep = 'convert';
export type GuestConvertRole = 'mentor' | 'mentee';

export type GuestIntakeAttribution = {
  source?: string | null;
  profileId?: string | null;
};

export type GuestIntakeRouteParams = GuestIntakeAttribution & {
  step?: GuestIntakeStep | null;
  role?: GuestConvertRole | null;
};

export function guestIntakePath({
  source,
  profileId,
  step,
  role,
}: GuestIntakeRouteParams = {}): string {
  const params = new URLSearchParams();
  if (source) {
    params.set('source', source);
  }
  if (profileId) {
    params.set(GUEST_PROFILE_PARAM, profileId);
  }
  if (step) {
    params.set(GUEST_INTAKE_STEP_PARAM, step);
  }
  if (role) {
    params.set(GUEST_INTAKE_ROLE_PARAM, role);
  }
  const query = params.toString();
  return query ? `${routes.GUEST_INTAKE}?${query}` : routes.GUEST_INTAKE;
}

export function guestIntakeConvertPath(params: Omit<GuestIntakeRouteParams, 'step'> = {}): string {
  return guestIntakePath({ ...params, step: 'convert' });
}

export function readGuestIntakeAttribution(searchParams: URLSearchParams): GuestIntakeAttribution {
  return {
    source: searchParams.get('source'),
    profileId: searchParams.get(GUEST_PROFILE_PARAM),
  };
}

export function readGuestIntakeRouteParams(searchParams: URLSearchParams): GuestIntakeRouteParams {
  const roleParam = searchParams.get(GUEST_INTAKE_ROLE_PARAM)?.trim().toLowerCase() ?? null;
  const role =
    roleParam === 'mentor' || roleParam === 'mentee' ? roleParam : null;
  const stepParam = searchParams.get(GUEST_INTAKE_STEP_PARAM);
  const step = stepParam === 'convert' ? 'convert' : null;

  return {
    ...readGuestIntakeAttribution(searchParams),
    step,
    role,
  };
}

export function isGuestConvertRole(value: string | null | undefined): value is GuestConvertRole {
  return value === 'mentor' || value === 'mentee';
}

export function registrationAttributionFromSearchParams(
  searchParams: URLSearchParams,
): GuestIntakeAttribution {
  const source = searchParams.get('source');
  const profileId = searchParams.get(GUEST_PROFILE_PARAM);
  if (source === QR_PROFILE_SOURCE || profileId) {
    return { source: source || QR_PROFILE_SOURCE, profileId };
  }
  if (source === QR_REGISTRATION_SOURCE) {
    return { source: QR_REGISTRATION_SOURCE };
  }
  return {};
}

export function appendAttributionToPath(path: string, attribution: GuestIntakeAttribution): string {
  const [base, existingQuery = ''] = path.split('?');
  const params = new URLSearchParams(existingQuery);
  if (attribution.source) {
    params.set('source', attribution.source);
  }
  if (attribution.profileId) {
    params.set(GUEST_PROFILE_PARAM, attribution.profileId);
  }
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
